import api from 'api';
import { errHelper } from 'utils';
import {
  setAssetAllocations,
  setPortfolioRiskScore,
  setPastPerformanceAggregates,
  setTotalPerformanceData,
  setExistingPoliciesCharges,
  setRecommendedPoliciesCharges,
  setRecommendedPoliciesRiskScore,
  setExistingPoliciesRiskScore,
  setSectorBreakdown,
  setCountryBreakdown,
  setRegionalBreakdown,
  setWithdrawals,
  setPolicies,
  setContributions,
  setContributionsSummary,
  setProviders,
  setHoldings,
  setRecommendedRiskAnalysis
} from '../Case/actions';
import {
  setExistingPolicies,
  setHasExistingPolicies
} from 'store/modules/Case/actions';

export const recommendationActions = {
  getPastPerformanceData:
    ({ portfolio }: any) =>
    (dispatch: any) => {
      return Promise.all([
        api.getPastPerformanceAggregateData({ portfolio }),
        api.getTotalPerformanceData({ portfolio })
      ]).then(([pasPerformanceAggregatess, totalPerformanceData]) => {
        dispatch(setPastPerformanceAggregates(pasPerformanceAggregatess.data));
        dispatch(setTotalPerformanceData(totalPerformanceData.data));
      });
    },
  getRecommendationData:
    ({ portfolio }: any) =>
    (dispatch: any) => {
      return Promise.all([
        api.getExistingPolicies({ portfolio }),
        api.getPolicies({ portfolio }),
        api.getContributions({ portfolio }),
        api.getContributionsSummary({ portfolio }),
        api.getWithdrawals({ portfolio }),
        api.getAssetAllocationData({ portfolio }),
        api.getPortfolioRiskScore({ portfolio }),
        api.getProviders(),
        api.getHoldings({ portfolio }),
        api.getExsitinPoliciesChargesData({ portfolio }),
        api.getRecommendedPoliciesChargesData({ portfolio }),
        api.getExistingPoliciesRiskScore({ portfolio }),
        api.getRecommendedPoliciesRiskScore({ portfolio }),
        api.getSectorBreakdownData({ portfolio }),
        api.getRegionalBreakdownData({ portfolio }),
        api.getCountryBreakdownData({ portfolio }),
        api.getRiskAnalysisData({ portfolio })
      ])
        .then(
          ([
            existingPolicies,
            recommendedPolicies,
            contributions,
            contributionSummary,
            withdrawals,
            assetAllocations,
            portfolioRiskScore,
            platforms,
            holdings,
            existingPoliciesCharges,
            recommendedPoliciesCharges,
            existingPoliciesRiskScore,
            recommendedPoliciesRiskScore,
            sectorBreakdown,
            regionalBreakdown,
            countryBreakdown,
            recommendedRiskAnalysis
          ]) => {
            const isExistigPoliciesExist =
              existingPolicies.data.results.length > 0;
            dispatch(setHasExistingPolicies(isExistigPoliciesExist));
            dispatch(setExistingPolicies(existingPolicies.data));
            dispatch(setPolicies(recommendedPolicies.data));
            dispatch(setContributions(contributions.data));
            dispatch(setContributionsSummary(contributionSummary.data));
            dispatch(setWithdrawals(withdrawals.data));
            dispatch(setAssetAllocations(assetAllocations.data));
            dispatch(setPortfolioRiskScore(portfolioRiskScore.data));
            dispatch(setProviders(platforms.data));
            dispatch(setHoldings(holdings.data));
            dispatch(setExistingPoliciesCharges(existingPoliciesCharges.data));
            dispatch(
              setRecommendedPoliciesCharges(recommendedPoliciesCharges.data)
            );
            dispatch(
              setExistingPoliciesRiskScore(existingPoliciesRiskScore.data)
            );
            dispatch(
              setRecommendedPoliciesRiskScore(recommendedPoliciesRiskScore.data)
            );
            dispatch(setSectorBreakdown(sectorBreakdown.data));
            dispatch(setRegionalBreakdown(regionalBreakdown.data));
            dispatch(setCountryBreakdown(countryBreakdown.data));
            dispatch(setRecommendedRiskAnalysis(recommendedRiskAnalysis.data));
          }
        )

        .catch(err => {
          errHelper(err);
        });
    }
};
